<div class="check-list">
    <div class="check-list-header" *ngIf="filtered.length">
        <mat-checkbox class="check-list-box" color="primary" [checked]="allFilteredSelected"
            (change)="toggleAllFiltered()">
            {{ (allFilteredSelected ? 'deselectAll' : 'selectAll') | translate }}
        </mat-checkbox>
        <span class="check-list-count">
            {{ 'selected' | translate | capitalizeFirst }}: {{ selectedCount }} / {{ options?.length || 0 }}
        </span>
    </div>

    <mat-list class="check-list-items">
        <mat-list-item *ngFor="let option of filtered; trackBy: trackByValue" class="check-list-item">
            <mat-checkbox class="check-list-box" color="primary" [checked]="isSelected(option)"
                [disabled]="option.disabled" (change)="toggle(option)">
                <!-- Plakietka odjeżdża do prawej krawędzi, żeby liczby stały w kolumnie, a nie tuż za nazwami. -->
                <span class="option-label">
                    <span class="option-name">{{ option.key }}</span>
                    <span class="option-badge" *ngIf="option.badge != null">{{ option.badge }}</span>
                </span>
            </mat-checkbox>
        </mat-list-item>
    </mat-list>

    <div class="check-list-empty" *ngIf="!filtered.length">{{ 'noResults' | translate }}</div>
</div>
